import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/layout.tsx");
